import React from 'react';

export const PhoneNumberCrossIcon = ({
  width = 20,
  height = 20,
  className = '',
}) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <g clipPath="url(#clip0_42087_111475)">
      <path
        d="M16.6668 5C16.8878 5 17.0998 5.0878 17.256 5.24408C17.4123 5.40036 17.5001 5.61232 17.5001 5.83333V14.1667C17.5001 14.3877 17.4123 14.5996 17.256 14.7559C17.0998 14.9122 16.8878 15 16.6668 15H7.50011L3.33344 10.8333C3.12846 10.6042 3.01514 10.3075 3.01514 10C3.01514 9.69253 3.12846 9.39584 3.33344 9.16667L7.50011 5H16.6668Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 8.3335L13.3333 11.6668M13.3333 8.3335L10 11.6668"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_42087_111475">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
